import { ThisConnector } from '../../../../api/connector'

export interface ApiCurrentUserProfile {
  user_uid: string
  first_name: string
  last_name: string
  rasp_enabled: boolean
  preferences: {
    language: string
    time_format: string
    date_format: string
    time_zone: string
  }
  serverless_enabled: boolean
}

export interface CurrentUserProfile {
  userUid: string
  firstName: string
  lastName: string
  protect: boolean
  serverless: boolean
  locale: string
  timeFormat: string
  dateFormat: string
  timeZone: string
  datePreference: {
    showPeriod: boolean
  }
}
export interface GetCurrentUserProfileArgs {
  organizationUuid: string
}

export async function getCurrentUserProfile(
  this: ThisConnector,
  { organizationUuid }: GetCurrentUserProfileArgs
) {
  const { user } = await this.connector.get(`/${organizationUuid}/profile`)

  return mapCurrentUserProfile(user)
}

export const mapCurrentUserProfile: (
  apiData: ApiCurrentUserProfile
) => CurrentUserProfile = ({
  user_uid: userUid,
  first_name: firstName,
  last_name: lastName,
  rasp_enabled: protect,
  serverless_enabled: serverless,
  preferences: {
    language: locale,
    time_format: timeFormat,
    date_format: dateFormat,
    time_zone: timeZone
  }
}) => ({
  userUid,
  firstName,
  lastName,
  protect,
  locale,
  timeFormat,
  dateFormat,
  timeZone,
  serverless,
  datePreference: {
    showPeriod: timeFormat.indexOf('a') > -1
  }
})
